import { getVoiceFormById, VoiceFormIntentId } from "./voiceFormRegistry";

/** Exact opening line the agent should speak on connect. */
export const VOICE_MENU_GREETING = "How can I help you today?";

export const VOICE_FORM_START_PROMPTS: Record<
  string,
  { title: string; hint: string }
> = {
  file_claim: {
    title: "File a claim",
    hint:
      "I can help you file a claim. Tell me what happened and we will go through the details.",
  },
  add_driver: {
    title: "Add driver",
    hint:
      "I can help you add a driver to your policy. What is the driver's first name?",
  },
  add_vehicle: {
    title: "Add vehicle",
    hint:
      "I can help you add a vehicle to your policy. What is the vehicle year and make?",
  },
};

export function buildIntentSwitchClientFields(
  formId: VoiceFormIntentId,
  options?: {
    policiesLoading?: boolean;
    accountPolicyTypes?: string;
  }
): Record<string, string> {
  const def = getVoiceFormById(formId);
  const start = VOICE_FORM_START_PROMPTS[formId];
  const payload: Record<string, string> = {
    formIntent: formId,
    formTitle: def?.title || start?.title || formId,
    dynamicFields: "{}",
    agentPromptHint:
      start?.hint ||
      `I can help with ${def?.title || formId}. What is the first detail?`,
  };
  if (options?.policiesLoading) {
    payload.policiesStatus = "loading";
  }
  if (options?.accountPolicyTypes?.trim()) {
    payload.accountPolicyTypes = options.accountPolicyTypes.trim();
  }
  if (formId === "add_driver" || formId === "add_vehicle") {
    payload.dynamicFieldLabels = "";
  }
  return payload;
}

export function isInternalTranscriptLeak(text: string): boolean {
  const t = text.trim();
  if (!t) return false;
  return (
    /\[INTERNAL\]/i.test(t) ||
    /instruction for the assistant only/i.test(t) ||
    /\bformIntent\b/i.test(t) ||
    /\bdynamicFields\b/i.test(t) ||
    /\bagentPromptHint\b/i.test(t) ||
    /do not read this message aloud/i.test(t) ||
    /the caller chose\b/i.test(t) ||
    /caller wants to add/i.test(t) ||
    /not related to a claim/i.test(t) ||
    /respond out loud to the caller/i.test(t) ||
    /one at a time\. start with/i.test(t)
  );
}
